// TODO: move this file to common api!

angular.module('zc.zenclerkS')
  .factory('AgencyProject', AgencyProject);

AgencyProject.$inject = ['$q', '$translate', 'Api', 'projectServiceResponseTransformer'];
function AgencyProject($q, $translate, Api, projectServiceResponseTransformer) {
  const PROJECT_STATUSES = [
    {
      name: $translate.instant('services.agencyProject.accountCreation'), // 0
    },
    {
      name: $translate.instant('services.agencyProject.companyInfo') // 1
    },
    {
      name: $translate.instant('services.agencyProject.siteInfo') // 2
    },
    {
      name: $translate.instant('services.agencyProject.ratePlan') // 3
    },
    {
      name: $translate.instant('services.agencyProject.trackingTag') // 4
    },
    {
      name: $translate.instant('services.agencyProject.conversionTag') // 5
    },
    {
      name: $translate.instant('services.agencyProject.campaignDelivered') // 6
    },
  ];

  const service = {
    all,
    create,
    calculateProjectStatus,
    setDemoData,
    projectStatuses: PROJECT_STATUSES
  };
  return service;

  function all(agencyId) {
    return Api.get(`/api/agencies/${agencyId}/projects`, {}, {
      cache: false,
      transformResponse: projectServiceResponseTransformer
    })
      .then(res => {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.projects;
      });
  }

  function create(agencyId, params) {
    return Api.post(`/api/agencies/${agencyId}/projects/`, params)
      .then(res => {
        if(!res.data.success) {
          return $q.reject(res);
        }
        return res.data.projects;
      });
  }

  function calculateProjectStatus(project) {
    if(!project.companyinfo_confirmed_at) {
      project.status = 0;
      project.status_last_updated_at = project.created_at;
    } else if(!project.siteinfo_confirmed_at) {
      project.status = 1;
      project.status_last_updated_at = project.companyinfo_confirmed_at;
    } else if(!project.pricing_confirmed_at) {
      project.status = 2;
      project.status_last_updated_at = project.siteinfo_confirmed_at;
    } else if(!project.tracking_tag_confirmed_at) {
      project.status = 3;
      project.status_last_updated_at = project.pricing_confirmed_at;
    } else if(!project.conversion_tag_confirmed_at) {
      project.status = 4;
      project.status_last_updated_at = project.tracking_tag_confirmed_at;
    } else if(project.started_campaigns.length === 0) {
      project.status = 5;
      project.status_last_updated_at = project.conversion_tag_confirmed_at;
    } else {
      // all is well
      project.status = 6;
      const campaignDates = _.map(project.started_campaigns, i => moment(i.created_at).toDate());
      project.status_last_updated_at = _.sortBy(campaignDates, i => -i)[0];
    }

    // Special case!
    // There might not be users at all for example if agency takes care of everything.
    // In this case pricing_confirmed_at will not be checked, and we should only look
    // at tags and campaigns. Still, there might be users in the project, but they
    // are agency users.
    // Tags are the most important things, next are campaigns
    if(project.tracking_tag_confirmed_at &&
        project.conversion_tag_confirmed_at &&
        project.reviewed_at && // just in case
        project.contracted_at && // will be set manually by emin
        project.started_campaigns.length > 0) {
      // should be ok, because agency handles
      project.status = 6;
      const campaignDates = _.map(project.started_campaigns, i => moment(i.created_at).toDate());
      project.status_last_updated_at = _.sortBy(campaignDates, i => -i)[0];
    }

    // convert to more human readable
    project.status_last_updated_str = moment(project.status_last_updated_at).tz(project.region).format('YYYY-MM-DD HH:mm');
  }

  function setDemoData(project) {
    let rand = Math.floor(Math.random() * Math.pow(10, 4));
    project.is_demo = true;
    project.title = 'Demo Site';
    project.base_url = `http://f${rand}.example.com/`;
    project.company_name = 'Demo Company';
    project.representative = 'Demo ';
    project.postal_code = '000-0000';
    project.address = '12345 Demo Street';
    project.phone_number = '080-1234-5678';
    project.invoice_calculation_type = 'normal';
    project.shopping_cart_asp = 'other';
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/agency_project.service.js